import React from "react";

import styles from "./TextOnPictureSmall.module.scss";

const TextOnPictureSmall = ({ product }: any) => {
  return (
    <a href={product.path}>
      <div
        className={styles.textOnPicture}
        style={{ backgroundImage: `url(${product.url}) ` }}
      >
        <div className={styles.sup} />
        <div className={styles.toHover}>
          <div className={styles.back} />
          <div className={styles.text}>
            {product.title}
            <div className={styles.price}> {product.price}</div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default TextOnPictureSmall;
